<template>
  <el-main :style="{ height: height + 'px' }">
    <div class="Scroll_content" :style="{ height: height + 'px' }">
      <div>
        <div class="simkeropl">{{ $t('information.Profile') }}</div>
        <div class="yinweimm">
          <span>{{ $t('information.Parent_Full_Time') }}</span>
          <div class="hanzi mlk">{{ userInfo.name == "" || !userInfo.name ? '-' : userInfo.name }}&nbsp;&nbsp;<img
              @click="chooseEditName" src="../../assets/edit.png" alt=""></div>
        </div>
        <div class="yinweimm">
          <span>{{ $t('information.Phone_no') }}</span>
          <div class="hanzi mlk">+{{ userInfo.country_code }} {{ userInfo.mobile }}</div>
        </div>
        <div class="yinweimm">
          <span>{{ $t('information.Email') }}</span>

          <div class="hanzi mlk">{{ userInfo.email }}&nbsp;&nbsp;
            <img @click="chooseEditEmail" src="../../assets/edit.png" alt="">
          </div>
        </div>
        <div class="yinweimm">
          <span>{{ $t('information.Password') }}</span>
          <div class="hanzi mlk" @click="Jump">
            <img src="../../assets/edit.png" alt="">&nbsp;
            <span class="change-btn">{{ $t('information.Change') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dialogNameVisible" class="el-message-box__wrapper edit-email-mask">
      <div class="el-message-box edit-email-dialog">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <b>{{ $t('myChild.editProfile') }}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseEditName">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="edit-email-field">
            <label class="edit-email-label">{{ $t('information.Parent_Full_Time') }}</label>
            <el-input v-model="parentName" autocomplete="off" maxlength="50"></el-input>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button"
            class="el-button el-button--default el-button--small el-button--primary edit-email-save-btn"
            @click="toEditName">
            <span>{{ $t('main.send') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="dialogFormVisible" class="el-message-box__wrapper edit-email-mask">
      <div class="el-message-box edit-email-dialog">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <b>{{ $t('myChild.editProfile') }}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseEditEmail">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="edit-email-field">
            <label class="edit-email-label">{{ $t('information.Email') }}</label>
            <el-input v-model="email" autocomplete="off" maxlength="50"></el-input>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button"
            class="el-button el-button--default el-button--small el-button--primary edit-email-save-btn"
            @click="toEditEmail">
            <span>{{ $t('main.send') }}</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="userlang" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{ $t('information.editProfile') }}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooselang">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{ $t('information.Preferred_language') }}</p>
              <div>
                <el-select v-model="lang_new" :placeholder="$t('information.Preferred_language')">
                  <el-option :label="$t('information.English')" value="en">{{ $t('information.English') }}</el-option>
                  <el-option :label="$t('information.Simplified_Chinese')" value="zh_CN">{{ $t('information.Simplified_Chinese') }}</el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary"
            @click="language_xg">
            <span>{{ $t('main.send') }}</span>
          </button>
        </div>
      </div>
    </div>

    <reset-password-dialog
      :visible.sync="resetPasswordVisible"
      :reset-type="resetPasswordType"
    />

  </el-main>

</template>
<script>
import { setStore, getStore, keys } from '@/store';
import { normalizeLocale, switchUserLanguage } from '@/utils/lang';
import ResetPasswordDialog from './ResetPasswordDialog.vue'

export default {
  inject: ['reload'],
  components: {
    ResetPasswordDialog
  },
  // props:['balanceData'],
  data() {
    return {
      height: 100,
      userInfo: [],
      dialogFormVisible: false,
      dialogNameVisible: false,
      email: '',
      parentName: '',
      userlang: false,
      lang_new: '',
      resetPasswordVisible: false,
      resetPasswordType: 1,

    }

  },
  created() {
    let height = document.body.offsetHeight - 147;
    this.height = height;
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/onboarding'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
      return false
    }
    this.get_usInfo();
  },
  methods: {
    get_usInfo() {
      this.$http.get('/api/member/data').then((res) => {
        if (res.data.code == 200) {
          this.userInfo = res.data.data
          setStore(keys.userProfile, res.data.data)
          this.lang_new = normalizeLocale(this.userInfo.language ? this.userInfo.language : (navigator.language && navigator.language.toLowerCase().includes('zh-cn') ? 'zh_CN' : navigator.language))
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    /**
     * 跳转到设置密码模块
     */
    Jump: function () {
      this.$http.post('/api/checkPassHave').then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.data,
            type: 'success'
          })
          this.resetPasswordType = 1
          this.resetPasswordVisible = true
        } else if (res.data.code == 400) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          this.resetPasswordType = 0
          this.resetPasswordVisible = true
        }
      })
    },
    chooseEditName() {
      this.parentName = this.userInfo.name || ''
      this.dialogNameVisible = !this.dialogNameVisible
    },
    chooseEditEmail() {
      this.email = this.userInfo.email
      this.dialogFormVisible = !this.dialogFormVisible
    },
    toEditName() {
      if (this.parentName === '') {
        this.$message({
          message: this.$t('errorprompt.nameEmpty'),
          type: 'error'
        })
        return false
      }
      this.$http.post('/api/updateParentName', {
        name: this.parentName
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          this.chooseEditName()
          this.get_usInfo()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    chooselang() {
      this.userlang = !this.userlang
    },
    toEditEmail() {
      if (this.email == '') {
        this.$message({
          message: this.$t('errorprompt.emailEmpty'),
          type: 'error'
        })
        return false;
      }
      this.$http.post('/api/saveMail', {
        email: this.email
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.chooseEditEmail();
          this.get_usInfo();
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },

    language_xg() {
      switchUserLanguage(this, this.lang_new)
    }
  },
  mounted() {
  },
  computed: {
    lang() {
      var ter = normalizeLocale(this.userInfo.language ? this.userInfo.language : navigator.language)
      if (ter === 'en') {
        return this.$t('information.English')
      }
      return this.$t('information.Simplified_Chinese')
    },
  },
  watch: {

  },
}
</script>
<style lang="less" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.simkeropl {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 33px;
  color: #000000;
  margin-bottom: 48.41px;

}

.yinweimm {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  /* or 100% */
  display: flex;
  align-items: center;
  color: #B50604;
  margin-bottom: 24px;
  span{
    display: inline-block;width: 100px;
  }
}

.hanzi {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #010103;

  img {
    cursor: pointer;
  }
}

.insewre_bom {
  width: auto;
  height: auto;
  overflow: hidden;
}

.ziti {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 67px;
  color: #000000;
  float: left;
  margin-right: 25px;
}

.anniu {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */
  font-feature-settings: 'tnum' on, 'lnum' on;
  color: #FF6E17;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 10px 0px;
  float: left;
  border: 1px solid #FF6E17;
  cursor: pointer;
  padding: 10px;
  border-radius: 24px;
}

.img_kplin {
  position: relative;
  top: 6px;
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.edit-email-mask {
  z-index: 2010;
  background: rgba(0, 0, 0, 0.3);
}

.edit-email-dialog {
  width: 320px !important;
  min-width: 320px !important;
  background: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-radius: 8px;

  .el-message-box__header {
    padding: 20px;

    .el-message-box__title {
      text-align: left;
      font-size: 18px;
      font-weight: 500;
      color: #333;
      margin: 0;

      b {
        font-weight: 500;
      }
    }

    .el-message-box__headerbtn {
      top: 18px;
      right: 20px;

      .el-icon-close {
        color: #bdbdbd;
        font-size: 18px;
      }
    }
  }

  .el-message-box__content {
    padding: 8px 24px 20px;
  }

  .edit-email-field {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .edit-email-label {
    flex-shrink: 0;
    font-size: 14px;
    color: #666;
    white-space: nowrap;
  }

  /deep/ .el-input {
    flex: 1;
  }

  /deep/ .el-input__inner {
    height: 44px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    background: #fff;
    font-size: 14px;
    color: #666;
    padding: 0 16px;
    outline: none;
    box-shadow: none;

    &:focus {
      border-color: #b50604;
    }
  }

  .el-message-box__btns {
    padding: 0 24px 24px;
    text-align: center;
    margin: 0;
  }

  .edit-email-save-btn {
    width: 100%;
    height: 48px;
    background: #b50604 !important;
    border: none !important;
    border-radius: 10px;
    font-size: 16px;
    color: #fff !important;
    margin: 0;
  }
}
.change-btn{
  color: #b50604;
  font-size: 16px;
  cursor: pointer;
}

.el-message-box {
  background: #FAFAFA;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 14px;

  .el-message-box__header {
    padding: 20px;

    .el-message-box__title {
      margin-bottom: 10px;
      font-size: 24px;
    }

    .el-message-box__headerbtn {
      width: 20px;
    }
  }

  .el-message-box__content {
    color: #353643;
    padding: 0 20px 16px 20px;

    .el-message-box__message {
      .el-input {
        width: 100%;
        border-bottom: 1px solid #a5a5a5;
      }

      .errorPass {
        border-bottom: 1px solid #fc424c;
      }

      /deep/ .el-input__inner {
        -moz-appearance: none;
        height: 40px;
        border: none;
        background: none;
        font-size: 16px;
        color: #353643;
        font-family: Sofia Pro-Regular;
        letter-spacing: 0px;
        outline: 0;
        padding: 0 40px 0 0;
        border-radius: 0;
      }

      >p {
        margin-bottom: 10px;
        font-weight: bold;
      }
    }
  }

  .el-message-box__btns button {
    height: 42px;
    background: #4B69FE;
    border-radius: 8px;
    font-size: 16px;
    color: #FFFFFF;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/children/information.vue